import { useQuery, UseQueryResult } from 'react-query';
import { Context, Result, getAvailableLeadReview } from '@/services/getAvailableLeadReview';
import { handleUnauthorizedError } from '@/services/queryClient';
import {
  dispatchAvailableLeadReviewErrorEvent,
  dispatchAvailableLeadReviewSuccessEvent,
} from '@/utils/analyticsEvents';
import { ReactQueryKeys } from './keys';

type Props = {
  onSuccess?: (data: Result) => void;
  onError?: (datas: Error) => void;
};

type UseGetAvailableLeadReview = (
  context: Context,
  config?: Props,
) => UseQueryResult<Result, Error>;

const useGetAvailableLeadReview: UseGetAvailableLeadReview = (context, config) => {
  return useQuery(
    [ReactQueryKeys.GET_AVAILABLE_LEAD_REVIEW, { context }],
    () => getAvailableLeadReview(context),
    {
      onSuccess: (data): void => {
        const { reviewButton } = data;

        dispatchAvailableLeadReviewSuccessEvent(reviewButton);
        config?.onSuccess?.(data);
      },
      onError: (error: Error): void => {
        dispatchAvailableLeadReviewErrorEvent(error.message);
        handleUnauthorizedError(error);
        config?.onError?.(error);
      },
    },
  );
};

export { useGetAvailableLeadReview };
